import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HeartRunnerLeftMenuComponent from '../components/heartRunnerLeftMenuComponent';
import HeartRunnerHeaderComponent from '../components/heartRunnerHeaderComponent';
import HeartRunnerFooterComponent from '../components/heartRunnerFooterComponent';
import { HeartRunnerRouteComponent } from '../components/heartRunnerRouteComponent';
import { getFooterText } from '../actions/SuperAdminFooterAction'
import { logout, logOutHeartRunner } from '../../../HeartRunnerLogin/actions/heartRunnerLoginAction'
import ContextComponent from '../../../Context/contextComponent';

class HeartRunnerLayoutContainer extends Component {
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
    }

    componentWillMount() {
        console.log(this.props.login)
        // if (this.props.login.authTokenId != "") {

            
        // }else{
            
        //     logout();
        //     this.props.history.push('/superadmin/login');
        // }
        this.props.actions.getFooterText();
    }

    logout() {
        logout();
        this.props.actions.logOutHeartRunner();
        this.props.history.push('/heartrunnerlogin');
    }

    render() {
        return (
               <div> 
               
               <HeartRunnerLeftMenuComponent logout={this.logout} />
                <section className="wrapper scrollable">
                <HeartRunnerHeaderComponent logout={this.logout} />
                <div className="main-grid">
                <HeartRunnerRouteComponent />
                <ContextComponent />
                </div>
                <HeartRunnerFooterComponent footerText={this.props.footerText} />
                </section>
              </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getFooterText, 
            logOutHeartRunner
        }, dispatch)
    };
};

function mapStateToProps({ superAdminLayoutReducer,superAdminLoginReducer }) {
    return {
        footerText: superAdminLayoutReducer.footerText,
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.userId
        }

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeartRunnerLayoutContainer))